module.exports = __webpack_public_path__ + "static/media/background-5.150f388a.svg";